import React from "react";
import "./WitEarnHome.scss"
import TagContent from "../../components/TagContent/TagContent";
import GridCard from "../../components/GridCard/GridCard";
import OptionCard from "../../components/OptionCard/OptionCard";
import { sortByOrderAscending } from "../../helper/helper";


const WitEarnHomeFeatures = ({ components }) => {

    const getComponents = (key, component) => {
        switch (component.ID) {
            case "TagComponent":
                return <div className="WitEarnHomeFeatures-tg-cont">
                    <TagContent text={component?.Props?.text} isList={component?.Props?.isList} />
                </div>
            case "HeaderText":
                return <div className="WitEarnHomeFeatures-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomeFeatures-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomeFeaturesGrid":
                return <div className="WitEarnHomeFeatures-grid">
                    {component?.Data?.map((feature, index) => {
                        return <GridCard header={feature?.header} key={index} subheader={feature?.subheader} isLearnMore={feature?.isLearnMore} gridIcon={feature?.gridIcon} cardColor={feature.cardColor} />
                    })}
                </div>
            case "WitEarnHomeFeatureOptionsGrid":
                return <div className="WitEarnHomeFeatures-grid-opt">
                    {component?.Data?.map((feature, index) => {
                        return <OptionCard header={feature?.header} key={index} subheader={feature?.subheader} icon={feature?.icon} optionColor={feature.optionColor} options={feature?.options} />
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeFeatures">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomeFeatures